import { useEffect, useState } from 'react';
import { ory } from 'src/providers/authProvider';
import { Logger } from 'src/utils/Logger';

const AUTH_METHOD_LINK_RECOVERY = 'link_recovery';

export const useInviteFlowRedirect = (redirectTo: string = '/invite'): { isChecking: boolean } => {
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkForInviteFlow = async () => {
      try {
        const { data: session } = await ory.toSession();
        const authMethods = session.authentication_methods ?? [];
        const mostRecentMethod = authMethods[authMethods.length - 1]?.method;

        if (mostRecentMethod === AUTH_METHOD_LINK_RECOVERY) {
          window.location.replace(redirectTo);
          return;
        }
      } catch {
        Logger.info('No active session with link_recovery auth method');
      } finally {
        setIsChecking(false);
      }
    };

    checkForInviteFlow();
  }, [redirectTo]);

  return { isChecking };
};
